<script setup lang="ts">
import type {Media, Person} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import {type VariantProps, cva} from 'class-variance-authority'

const props = defineProps<{
  person: Populated<Person> & {partnerName?: string}
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <NuxtImg
      v-if="person?.image"
      loading="lazy"
      format="webp"
      class="mt-8 h-24 w-24 rounded-full"
      v-bind="resolveMediaProps(person?.image)"
      :width="128"
      :height="128"
    />

    <div class="text-center font-medium dark:text-white">
      <Heading size="small" class="mt-4 pb-1">{{ person?.name }}</Heading>
      <Paragraph size="normal" weight="normal" class="text-lg font-bold !tracking-tight !text-gray-900">
        {{ person?.partnerName ? `${person?.role || ''} ${person?.partnerName}` : person?.role }}
      </Paragraph>
    </div>
  </div>
</template>
